module.exports = __webpack_public_path__ + "img/trace-olives-mobile.9de1e9c.png";